/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import React, { useState } from 'react'
import { useRouter } from 'next/navigation'
import { parseUrl } from '@hashicorp/react-components/src/lib/parse-url'
import sendPosthogEvent from '@web/utils/send-posthog-event'
import Form from 'components/marketo-form'
import s from './style.module.css'

type WebinarRegistrationFormProps = {
	webinarId: string
	product: string[]
	title: string
	marketoFormId: number
	destinationUrl?: string
	formTitle?: string
}

export default function RegistrationForm({
	webinarId,
	product,
	title,
	marketoFormId,
	destinationUrl,
	formTitle = 'Register for the live webinar',
}: WebinarRegistrationFormProps) {
	const [globalError, setGlobalError] = useState(null)
	const router = useRouter()
	const successUrl = destinationUrl
		? parseUrl(destinationUrl).href
		: '/thank-you/webinar'

	return (
		<>
			<h4 className={`g-type-display-4 ${s.heading}`}>{formTitle}</h4>
			<Form
				formId={marketoFormId.toString()}
				initialValues={{ registeredWebinarID: webinarId }}
				onSubmitSuccess={() => {
					sendPosthogEvent('Webinar Signed Up', {
						...(product?.length && { product: product[0] }),
						title: title,
						webinar_id: webinarId,
						sales_contact_requested: false,
					})

					router.push(successUrl)
				}}
				onSubmitError={() => {
					setGlobalError(
						'Unfortunately something went wrong. Please try again later.',
					)
				}}
			/>
			{globalError && (
				<div className="global-error g-type-body-small error">
					{globalError}
				</div>
			)}
		</>
	)
}
